import React, {useState} from 'react';
import styles from './SelectedOvalToolbar.module.css';
import useDismissableMenu from '../app-shell/useDismissableMenu';
import {MenuPanel, MenuButton, MenuLabel} from '../app-shell/MenuPanel';
import {ChevronDownIcon, TrashIcon} from './EditorIcons';
import {STATES} from '../lib/PageConstants';

const STATUS_ORDER = ['NOT_DONE', 'IN_PROGRESS', 'DONE'];
const STATUS_LABEL = {NOT_DONE: 'To do', IN_PROGRESS: 'Doing', DONE: 'Done'};

const AssigneePicker = ({assignee, assignees, onChange}) => {
    const [open, setOpen] = useState(false);
    const {triggerRef, menuRef} = useDismissableMenu(open, () => setOpen(false));

    if (!assignees) return null;

    return (
        <div className={styles.menuWrap}>
            <button
                ref={triggerRef}
                type="button"
                aria-label={assignee ? `Assignee: ${assignee.initials}. Change assignee` : 'Assign'}
                aria-haspopup="menu"
                aria-expanded={open}
                className={styles.assigneeButton}
                onClick={() => setOpen((o) => !o)}
            >
                {assignee ? (
                    <span className={styles.avatar} style={{background: assignee.colour}}>{assignee.initials}</span>
                ) : (
                    <span className={styles.assignText}>Assign</span>
                )}
                <ChevronDownIcon/>
            </button>
            {open && (
                <MenuPanel ref={menuRef} label="Assignee" align="start">
                    <MenuLabel>Assign to</MenuLabel>
                    <MenuButton onClick={() => {onChange(null); setOpen(false);}}>None</MenuButton>
                    {assignees.map((a) => (
                        <MenuButton key={a.id} onClick={() => {onChange(a); setOpen(false);}}>
                            <span className={styles.avatar} style={{background: a.colour}}>{a.initials}</span>
                            {a.name}
                        </MenuButton>
                    ))}
                </MenuPanel>
            )}
        </div>
    );
};

// The floating bar shown above (or below, if there's no room) the selected
// oval: status group, assignee picker, delete. Positioned by the caller
// (Page.js), which knows the oval's current screen coordinates.
const SelectedOvalToolbar = ({label, style, status, onStatusChange, assignee, assignees, onAssigneeChange, onDelete}) => (
    <div
        role="toolbar"
        aria-label={`Selected oval: ${label || 'task'}`}
        className={styles.bar}
        style={style}
    >
        <div role="group" aria-label="Status" className={styles.statusGroup}>
            {STATUS_ORDER.map((key) => {
                const state = STATES[key];
                const pressed = status === key;
                return (
                    <button
                        key={key}
                        type="button"
                        aria-pressed={pressed}
                        className={styles.statusButton}
                        style={pressed ? {background: state.fillColour, color: state.textColour} : undefined}
                        onClick={() => onStatusChange(key)}
                    >
                        <span className={styles.statusDot} style={{background: state.colour}}/>
                        {STATUS_LABEL[key]}
                    </button>
                );
            })}
        </div>
        <span className={styles.divider}/>
        <AssigneePicker assignee={assignee} assignees={assignees} onChange={onAssigneeChange}/>
        <button type="button" aria-label="Delete oval" className={styles.deleteButton} onClick={onDelete}>
            <TrashIcon/>
        </button>
    </div>
);

export default SelectedOvalToolbar;
